import React from "react";
import { _goToNote } from "routers/helper";

import { View, StyleSheet, TouchableOpacity } from "react-native";
import Icon from "components/Icon";
import Text from "components/Text";

import { colors, sizes, strings } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import css from "styles";

const NoteBox: React.FC<{ note: NoteT }> = ({ note }) => {
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  const { title, customer, customer_id, create_date, create_time } = note;

  const _goToEdit = () => _goToNote({ data: note });

  const iconColor =
    customer_id === null
      ? colors.purple
      : customer === null
      ? colors.danger
      : colors.theme;

  return (
    <>
      <TouchableOpacity
        onPress={_goToEdit}
        activeOpacity={sizes.tapOpacity}
        style={styles.box}
      >
        <View style={{ ...css.rRowCenterAlignSpaceBetween, marginBottom: 10 }}>
          <Text weight="extraBold" size={"lg"}>
            {title}
          </Text>
          <View style={{ top: 2, marginRight: 5 }}>
            <Icon style={{ left: -5 }} size={22} name="chevron-left" />
          </View>
        </View>

        <View style={css.rRowCenterAlignSpaceBetween}>
          <View style={css.rRowCenterAlign}>
            <Icon name="user" size={13} color={iconColor} />
            <Text
              color={colors.text.gray}
              style={{ marginRight: sizes.iconTextSpace }}
              weight="bold"
            >
              {customer_id === null
                ? strings.personal_note
                : customer === null
                ? strings.deleted_customer
                : customer?.name.trim()}
            </Text>
          </View>

          <View style={css.rRowCenterAlign}>
            <Icon name="calendar" size={13} color={iconColor} />
            <Text
              style={{ marginRight: sizes.iconTextSpace, marginLeft: 10 }}
              weight="bold"
              size={"sm"}
              color={colors.text.gray}
            >
              {create_date}
            </Text>

            <Icon name="clock" size={13} color={iconColor} />
            <Text
              style={{ marginRight: sizes.iconTextSpace }}
              weight="bold"
              size={"sm"}
              color={colors.text.gray}
            >
              {create_time}
            </Text>

            {/* <Text weight="medium" style={{ letterSpacing: 1.1 }}>
              ({create_time})
            </Text> */}
          </View>
        </View>
      </TouchableOpacity>
    </>
  );
};

export default React.memo(NoteBox);

const styles = StyleSheet.create({
  box: {
    borderRadius: sizes.radius.xl,
    backgroundColor: colors.itemsBg,
    paddingVertical: 10,
    paddingHorizontal: sizes.space,
  },

  header: {
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "space-between",
    height: 25,
  },

  type: { flexDirection: "row", alignItems: "center" },

  titleContainer: { flex: 1, alignItems: "flex-end" },

  footer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  growContainer: { flexGrow: 1 },
});
